export const SET_THREAD_DRAFT = 'SET_THREAD_DRAFT'
